"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@attensi/core");
var href_1 = require("./href");
var utils_1 = require("./utils");
exports.createEntry = function (href, include) {
    if (include === void 0) { include = {
        query: true,
        sessionStorage: true,
        localStorage: true,
    }; }
    var parsedHref = href_1.parseHref(href || window.location.href);
    var query = parsedHref.query;
    var subdomainFromPath = parsedHref.firstElementFromPath;
    return {
        /**
         * Removes old and stores new param, in either sessionStorage or localStorage
         * based on the optional `remember_me` argument
         */
        storeParam: function (key, value, rememberMe) {
            return utils_1.storeKeyValuePair(key, value, rememberMe);
        },
        /**
         * Removes old and stores new params, in either sessionStorage or localStorage
         * based on the optional `remember_me` argument
         */
        storeParams: function (params, rememberMe) {
            var keys = Object.keys(params);
            keys.forEach(function (key) {
                var value = params[key];
                if (key && value) {
                    utils_1.storeKeyValuePair(key, value, rememberMe);
                }
            });
        },
        /**
         * Return access_token from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {string | null}
         */
        getAccessToken: function () {
            return utils_1.getParam(query, include, core_1.AttensiParam.ACCESS_TOKEN);
        },
        /**
         * Return api_token from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {string | null}
         */
        getApiToken: function () {
            return utils_1.getParam(query, include, core_1.AttensiParam.API_TOKEN);
        },
        /**
         * Return attensi_client from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {AttensiClient | null}
         */
        getAttensiClient: function () {
            var str = utils_1.getParam(query, include, core_1.AttensiParam.ATTENSI_CLIENT);
            if (!str) {
                return null;
            }
            return core_1.stringToAttensiClient(str);
        },
        /**
         * Return company_name_key from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {string | null}
         */
        getCompanyNameKey: function () {
            return utils_1.getParam(query, include, core_1.AttensiParam.COMPANY_NAME_KEY);
        },
        /**
         * Return environment from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {AttensiEnvironment | null}
         */
        getEnvironment: function () {
            var environmentString = utils_1.getParam(query, include, core_1.AttensiParam.ENVIRONMENT);
            if (environmentString) {
                return core_1.stringToEnvironment(environmentString);
            }
            return null;
        },
        /**
         * Return locale from sources in order:
         * 1. query params
         * 2. sessionStorage
         * 3. localStorage
         *
         * @returns {string | null}
         */
        getLocale: function () {
            return utils_1.getParam(query, include, core_1.AttensiParam.LOCALE);
        },
        /**
         * Return remember_me from sources in order:
         * 1. query params
         *
         * @returns {boolean | null}
         */
        getRememberMe: function () {
            return utils_1.getBool(query, include, 'remember_me');
        },
        /**
         * Return subdomain from sources in order:
         * 1. query params
         * 2. path
         * 3. sessionStorage
         * 4. localStorage
         *
         * @returns {string | null}
         */
        getSubdomain: function (subdomainInclude) {
            var inc = subdomainInclude || __assign(__assign({}, include), { path: true });
            var subdomain = [
                /* Prio 1: query */
                inc.query ? utils_1.getStringFromQuery(query, core_1.AttensiParam.SUBDOMAIN) : null,
                /* Prio 2: path */
                inc.path ? subdomainFromPath : null,
                /* Prio 3: sessionStorage */
                inc.sessionStorage ? utils_1.getStringFromSessionStorage(core_1.AttensiParam.SUBDOMAIN) : null,
                /* Prio 4: localStorage */
                inc.localStorage ? utils_1.getStringFromLocalStorage(core_1.AttensiParam.SUBDOMAIN) : null,
            ];
            return subdomain.find(function (s) { return s; }) || null;
        },
        /**
         * Return <param> from sources in order:
         * 1. query params
         * 3. sessionStorage
         * 4. localStorage
         *
         * @returns {string | null}
         */
        getParam: function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return utils_1.getParam.apply(void 0, __spreadArrays([query, include], params));
        },
        /**
         * Return <bool> from sources in order:
         * 1. query params
         * 3. sessionStorage
         * 4. localStorage
         *
         * @returns {bool | null}
         */
        getBool: function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return utils_1.getBool.apply(void 0, __spreadArrays([query, include], params));
        },
        /**
         * Query as parsed from href
         */
        query: query,
    };
};
//# sourceMappingURL=entry.js.map